import { useEffect } from "react";
import { authLocalData, authStore } from "../../../stores/AuthStore";
import styles from "../Login.module.css";
import Reload from "./icons/reload.svg?react";
import { observer } from "mobx-react-lite";

export const ImageCaptcha = observer(() => {
  const { isImage, isLoadingImage, getImage } = authStore;
  const { clearFields, setValuePhrase } = authLocalData;

  useEffect(() => {
    getImage();
  }, []);

  const handleReload = () => {
    setValuePhrase([]);
    authStore.clearError();
    getImage();
    clearFields();
  };

  return (
    <div className={`${styles.divImageAndReload} ${authStore.isLoadingImage && styles.loadingImage}`}>
      <div className={`${styles.imageDiv}`}>{!isLoadingImage && isImage && <img src={isImage} />}</div>
      <Reload onClick={handleReload} className={styles.reload} />
    </div>
  );
});
